import React, { useState } from 'react';
import { 
  Typography, 
  Box, 
  Tabs, 
  Tab, 
  Paper, 
  Divider,
  Button,
  Modal,
  IconButton
} from '@mui/material';
import { 
  MedicalServices, 
  AssessmentOutlined, 
  DescriptionOutlined,
  LibraryBooksOutlined,
  VisibilityOutlined,
  ArticleOutlined,
  Close
} from '@mui/icons-material';

// Import components from the correct paths
import Header from '../component/layout/Header';
import PatientCard from '../component/layout/PatientCard';
import SymptomsAndFindings from '../component/diagnosis/SymptomsAndFindings';
import DocumentoClinico from '../component/clinical-document/DocumentoClinico';

import TopHeader from "../../../components/common/Header/TopHeader";
// Importar los datos mock
import { diagnosisAnalysisData } from '../mock/mocksAnalysis';
import { completeSnomedHierarchy } from '../mock/snomedHierarchy';

const DiagnosticAssistantList = () => {
  // Estado para la pestaña activa
  const [pestanaActiva, setPestanaActiva] = useState(0);
  
  // Nuevos estados para el flujo de diagnósticos
  const [diagnosticoSeleccionado, setDiagnosticoSeleccionado] = useState(null);
  const [mostrarAnalisisDetallado, setMostrarAnalisisDetallado] = useState(false);
  const [datosMockSeleccionados, setDatosMockSeleccionados] = useState(null);
  
  // Estado para mostrar el documento clínico como modal
  // const [mostrarDocumentoClinico, setMostrarDocumentoClinico] = useState(false);
  const [diagnosticosState, setDiagnosticosState] = useState([]);
  const [sintomasSeleccionados, setSintomasSeleccionados] = useState([]);
  // En la parte superior de tu componente, junto con otros useState
const [documentoClinico, setDocumentoClinico] = useState({
  open: false,
  paciente: null,
  diagnosticoSeleccionado: null,
  datosMockSeleccionados: null,
  diagnosticosConfirmados: [],
  diagnosticosDescartados: [],
  sintomasSeleccionados: []
});

const handleSintomasChange = (sintomas) => {
  setSintomasSeleccionados(sintomas);
};
  

  // Datos del paciente (estos vendrían de una API)
  const paciente = {
    nombre: 'Carlos Méndez',
    edad: 49,
    sexo: 'Masculino',
    nrHistoria: 'NV-602983',
    fechaConsulta: '03/04/2023'
  };

  // Función para mapear el diagnóstico seleccionado con los datos mock
const mapearConDatosMock = (diagnosis) => {
  // Obtener el nombre del diagnóstico de diferentes propiedades posibles
  const diagnosticName = diagnosis.diagnosticName || diagnosis.term || diagnosis.nombre || diagnosis.name;
  
  console.log('🔍 Mapeando diagnóstico:', diagnosticName);
  
  // Crear un mapeo basado en el nombre del diagnóstico
  const mappingKeys = {
    'Síndrome Coronario Agudo': 'syndrome-coronario-agudo',
    'Angina Inestable': 'angina-inestable',
    'Pericarditis Aguda': 'pericarditis-aguda',
    'Neumonía Adquirida en la Comunidad': 'neumonia-adquirida-comunidad',
    'Enfermedad por Reflujo Gastroesofágico': 'reflujo-gastroesofagico',
    'Tromboembolismo Pulmonar': 'tromboembolismo-pulmonar'
  };

  const mockKey = mappingKeys[diagnosticName];
  
  if (mockKey) {
    console.log('✅ Clave mock encontrada:', mockKey);
    return diagnosisAnalysisData[mockKey];
  } else {
    console.warn('❌ No se encontró mapeo para:', diagnosticName);
    console.log('🔑 Claves disponibles:', Object.keys(mappingKeys));
    return null;
  }
};

  // Función para manejar la selección de diagnóstico desde SymptomsAndFindings
const handleDiagnosisSelection = (diagnosis) => {
  // Log del diagnóstico completo
  console.log('Diagnóstico seleccionado:', diagnosis);
  
  // Log específico del nombre del diagnóstico
  console.log('Nombre del diagnóstico:', diagnosis.diagnosticName || diagnosis.term || diagnosis.nombre || diagnosis.name);
  
  // También puedes mostrar otros campos relevantes
  if (diagnosis.diagnosticName) {
    console.log('🏥 Diagnóstico recibido:', diagnosis.diagnosticName);
  }
  
  if (diagnosis.term) {
    console.log('📋 Término:', diagnosis.term);
  }
  
  if (diagnosis.selectedSymptoms) {
    console.log('🔍 Síntomas seleccionados:', diagnosis.selectedSymptoms);
  }
  
  if (diagnosis.analysisData) {
    console.log('📊 Datos de análisis:', diagnosis.analysisData);
  }
  
  // Mapear con datos mock
  const datosMock = mapearConDatosMock(diagnosis);
  
  if (datosMock) {
    setDiagnosticoSeleccionado(diagnosis);
    setDatosMockSeleccionados(datosMock);
    setMostrarAnalisisDetallado(true);
    console.log('✅ Datos mock encontrados:', datosMock.name);
  } else {
    const diagnosticName = diagnosis.diagnosticName || diagnosis.term || diagnosis.nombre || diagnosis.name;
    console.warn('⚠️ No se encontraron datos mock para:', diagnosticName);
    // Mostrar diagnóstico sin datos mock detallados
    setDiagnosticoSeleccionado(diagnosis);
    setDatosMockSeleccionados(null);
    setMostrarAnalisisDetallado(true);
  }
};

const handleDiagnosisStatusChange = (diagnosisData) => {
  setDiagnosticosState(prevState => {
    const existingIndex = prevState.findIndex(d => d.diagnosisId === diagnosisData.diagnosisId);
    
    if (existingIndex >= 0) {
      // Actualizar diagnóstico existente
      const updatedState = [...prevState];
      if (diagnosisData.status === null) {
        // Remover si el status es null (deseleccionado)
        updatedState.splice(existingIndex, 1);
      } else {
        // Actualizar status
        updatedState[existingIndex] = { ...updatedState[existingIndex], ...diagnosisData };
      }
      return updatedState;
    } else if (diagnosisData.status !== null) {
      // Agregar nuevo diagnóstico si tiene status
      return [...prevState, diagnosisData];
    }
    
    return prevState;
  });
};

  // Función para cerrar el análisis detallado
  const handleCloseAnalysis = () => {
    console.log('Cerrando análisis detallado');
    setMostrarAnalisisDetallado(false);
    setDiagnosticoSeleccionado(null);
    setDatosMockSeleccionados(null);
  };

 // Función completa para generar documento clínico médico
const handleGenerarDocumentoClinico = () => {
  if (!diagnosticoSeleccionado || !datosMockSeleccionados) {
    alert('Debe seleccionar un diagnóstico con datos completos para generar el documento clínico.');
    return;
  }

  // Obtener diagnósticos confirmados y descartados del estado
  const diagnosticosConfirmados = diagnosticosState.filter(d => d.status === 'confirmed');
  const diagnosticosDescartados = diagnosticosState.filter(d => d.status === 'discarded');
  const diagnosticosPendientes = diagnosticosState.filter(d => !d.status || d.status === 'pending');

  // ✅ VALIDACIÓN: Verificar que haya al menos un diagnóstico confirmado o descartado
  if (diagnosticosConfirmados.length === 0 ) {
    alert('❌ Error: No hay diagnósticos procesados\n\n📋 Para generar el documento clínico debe:\n• Confirmar al menos un diagnóstico, \n\n💡 Use los botones ✅ Confirmar o ❌ Descartar en la lista de diagnósticos.');
    return;
  }

  // 🔄 Ordenar confirmados por probabilidad (mayor a menor)
  const diagnosticosConfirmadosOrdenados = diagnosticosConfirmados
    .sort((a, b) => (b.probability || 0) - (a.probability || 0));

  // 🔄 Ordenar descartados por probabilidad inicial
  const diagnosticosDescartadosOrdenados = diagnosticosDescartados
    .sort((a, b) => (b.probability || 0) - (a.probability || 0));

  // Configurar modal con información completa
  setDocumentoClinico({
    open: true,
    paciente: paciente,
    diagnosticoSeleccionado: diagnosticoSeleccionado,
    datosMockSeleccionados: datosMockSeleccionados,
    diagnosticosConfirmados: diagnosticosConfirmadosOrdenados,
    diagnosticosDescartados: diagnosticosDescartadosOrdenados,
    diagnosticosPendientes: diagnosticosPendientes,
    sintomasSeleccionados: sintomasSeleccionados || []
  });

  // 📄 GENERAR CONTENIDO DEL DOCUMENTO
  const fechaGeneracion = new Date().toLocaleString('es-ES', {
    day: '2-digit',
    month: '2-digit', 
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit'
  });

  let contenidoDocumento = '';

  // ❌ CASO 1: Solo diagnósticos descartados
  if (diagnosticosConfirmados.length === 0 && diagnosticosDescartados.length > 0) {
    contenidoDocumento = generarDocumentoSoloDescartados(
      paciente, 
      diagnosticosDescartadosOrdenados, 
      fechaGeneracion
    );
  } 
  // ✅ CASO 2: Hay diagnósticos confirmados
  else {
    contenidoDocumento = generarDocumentoCompleto(
      paciente,
      datosMockSeleccionados,
      diagnosticosConfirmadosOrdenados,
      diagnosticosDescartadosOrdenados,
      diagnosticosPendientes,
      diagnosticosState,
      fechaGeneracion
    );
  }

  // Mostrar documento generado
  //alert(contenidoDocumento);

  // Log para desarrollo
  console.log('🏥 Documento clínico generado:', {
    confirmados: diagnosticosConfirmadosOrdenados.length,
    descartados: diagnosticosDescartadosOrdenados.length,
    pendientes: diagnosticosPendientes.length,
    fecha: fechaGeneracion
  });
};

// 📋 Función para generar documento solo con descartados
const generarDocumentoSoloDescartados = (paciente, diagnosticosDescartados, fechaGeneracion) => {
  return `
══════════════════════════════════════════════════════════════
📋 DOCUMENTO CLÍNICO - EVALUACIÓN DIAGNÓSTICA
══════════════════════════════════════════════════════════════

🏥 INSTITUCIÓN: ${paciente.institucion || 'Centro Médico'}
📅 FECHA Y HORA: ${fechaGeneracion}
🔍 TIPO DE DOCUMENTO: Evaluación de Diagnósticos Descartados

──────────────────────────────────────────────────────────────
👤 INFORMACIÓN DEL PACIENTE
──────────────────────────────────────────────────────────────
• Nombre completo: ${paciente.nombre}
• Edad: ${paciente.edad} años
• Sexo: ${paciente.sexo}
• N° Historia Clínica: ${paciente.nrHistoria}
• Fecha de consulta: ${paciente.fechaConsulta}
• Médico tratante: ${paciente.medicoTratante || 'No especificado'}

──────────────────────────────────────────────────────────────
❌ DIAGNÓSTICOS DESCARTADOS (${diagnosticosDescartados.length})
──────────────────────────────────────────────────────────────
${diagnosticosDescartados.map((diag, index) => `
${index + 1}. ${diag.diagnosisName}
   📊 Probabilidad inicial evaluada: ${diag.probability}%
   🔍 Severidad considerada: ${diag.severity || 'No especificada'}
   🏥 Especialidad: ${Array.isArray(diag.specialty) ? diag.specialty.join(', ') : diag.specialty || 'No especificada'}
   🫀 Sistema corporal: ${diag.bodySystem || 'No especificado'}
   ❌ Motivo de descarte: Evidencia clínica insuficiente o factores contradictorios
   📅 Fecha de descarte: ${diag.timestamp ? new Date(diag.timestamp).toLocaleString('es-ES') : 'No registrada'}
   ${diag.contradictingFactors && diag.contradictingFactors.length > 0 ? 
     `⚠️  Factores contradictorios (${diag.contradictingFactors.length}):
      ${diag.contradictingFactors.map(factor => `     - ${factor}`).join('\n')}` : ''}
`).join('\n')})

──────────────────────────────────────────────────────────────
📋 CONCLUSIONES Y RECOMENDACIONES
──────────────────────────────────────────────────────────────
🔍 EVALUACIÓN CLÍNICA:
Los diagnósticos evaluados han sido descartados tras análisis exhaustivo 
de la evidencia clínica disponible. Los factores contradictorios o la 
insuficiencia de criterios diagnósticos no permiten confirmar estas 
condiciones médicas.

📝 RECOMENDACIONES:
• Continuar con evaluación diagnóstica diferencial
• Realizar estudios complementarios según criterio clínico
• Seguimiento clínico estrecho del paciente
• Reevaluación periódica de síntomas y signos
• Consideración de consulta especializada si es necesario

──────────────────────────────────────────────────────────────
📊 RESUMEN ESTADÍSTICO
──────────────────────────────────────────────────────────────
• Total de diagnósticos evaluados: ${diagnosticosDescartados.length}
• Diagnósticos descartados: ${diagnosticosDescartados.length}
• Diagnósticos confirmados: 0
• Estado del proceso diagnóstico: En evaluación

──────────────────────────────────────────────────────────────
⚕️ INFORMACIÓN DEL SISTEMA
──────────────────────────────────────────────────────────────
• Sistema: SaludTI - Asistente de Diagnóstico SNOMED CT
• Versión: 2.0
• Documento generado: ${fechaGeneracion}
• Validez: Este documento es una herramienta de apoyo diagnóstico

══════════════════════════════════════════════════════════════
                         FIN DEL DOCUMENTO
══════════════════════════════════════════════════════════════`;
};

// 📋 Función para generar documento completo
const generarDocumentoCompleto = (
  paciente, 
  datosMockSeleccionados, 
  diagnosticosConfirmados, 
  diagnosticosDescartados, 
  diagnosticosPendientes,
  diagnosticosState,
  fechaGeneracion
) => {
  return `
══════════════════════════════════════════════════════════════
📋 DOCUMENTO CLÍNICO COMPLETO - EVALUACIÓN DIAGNÓSTICA
══════════════════════════════════════════════════════════════

🏥 INSTITUCIÓN: ${paciente.institucion || 'Centro Médico'}
📅 FECHA Y HORA: ${fechaGeneracion}
🔍 TIPO DE DOCUMENTO: Informe Diagnóstico Integral

──────────────────────────────────────────────────────────────
👤 INFORMACIÓN DEL PACIENTE
──────────────────────────────────────────────────────────────
• Nombre completo: ${paciente.nombre}
• Edad: ${paciente.edad} años
• Sexo: ${paciente.sexo}
• N° Historia Clínica: ${paciente.nrHistoria}
• Fecha de consulta: ${paciente.fechaConsulta}
• Médico tratante: ${paciente.medicoTratante || 'No especificado'}
• Servicio: ${paciente.servicio || 'No especificado'}

──────────────────────────────────────────────────────────────
🩺 DIAGNÓSTICO PRINCIPAL ANALIZADO
──────────────────────────────────────────────────────────────
• Denominación: ${datosMockSeleccionados.name}
• Código SNOMED CT: ${datosMockSeleccionados.snomedCode}
• Descripción clínica: ${datosMockSeleccionados.description}
• Categoría: ${datosMockSeleccionados.category || 'No especificada'}

──────────────────────────────────────────────────────────────
✅ DIAGNÓSTICOS CONFIRMADOS (${diagnosticosConfirmados.length})
   [Ordenados por prioridad clínica - mayor a menor probabilidad]
──────────────────────────────────────────────────────────────
${diagnosticosConfirmados.map((diag, index) => {
  const prioridad = index === 0 ? '🥇 PRINCIPAL' : 
                   index === 1 ? '🥈 SECUNDARIO' : 
                   index === 2 ? '🥉 TERCIARIO' : 
                   `${index + 1}° ORDEN`;
  
  return `
${index + 1}. ${diag.diagnosisName} ${prioridad}
   📊 Probabilidad diagnóstica: ${diag.probability}% ${index === 0 ? '⭐ MAYOR PRIORIDAD' : ''}
   🔍 Nivel de severidad: ${diag.severity || 'No especificado'}
   🏥 Especialidad requerida: ${Array.isArray(diag.specialty) ? diag.specialty.join(', ') : diag.specialty || 'Medicina General'}
   🫀 Sistema corporal afectado: ${diag.bodySystem || 'No especificado'}
   ✅ Factores de apoyo identificados: ${diag.supportingFactors ? diag.supportingFactors.length : 0}
   ${diag.supportingFactors && diag.supportingFactors.length > 0 ? 
     `🔍 Evidencia clínica de apoyo:
      ${diag.supportingFactors.map(factor => `     - ${factor}`).join('\n')}` : ''}
   📅 Fecha de confirmación: ${diag.timestamp ? new Date(diag.timestamp).toLocaleString('es-ES') : 'No registrada'}
   ${diag.notes ? `📝 Notas clínicas: ${diag.notes}` : ''}
`;
}).join('')}

${diagnosticosDescartados.length > 0 ? `
──────────────────────────────────────────────────────────────
❌ DIAGNÓSTICOS DESCARTADOS (${diagnosticosDescartados.length})
──────────────────────────────────────────────────────────────
${diagnosticosDescartados.map((diag, index) => `
${index + 1}. ${diag.diagnosisName}
   📊 Probabilidad inicial: ${diag.probability}%
   ❌ Motivo de descarte: Factores contradictorios o evidencia insuficiente
   ${diag.contradictingFactors && diag.contradictingFactors.length > 0 ? 
     `⚠️  Factores contradictorios (${diag.contradictingFactors.length}):
      ${diag.contradictingFactors.map(factor => `     - ${factor}`).join('\n')}` : ''}
   📅 Fecha de descarte: ${diag.timestamp ? new Date(diag.timestamp).toLocaleString('es-ES') : 'No registrada'}
`).join('')}` : ''}

${diagnosticosPendientes.length > 0 ? `
──────────────────────────────────────────────────────────────
⏳ DIAGNÓSTICOS PENDIENTES DE EVALUACIÓN (${diagnosticosPendientes.length})
──────────────────────────────────────────────────────────────
${diagnosticosPendientes.map((diag, index) => `
${index + 1}. ${diag.diagnosisName}
   📊 Probabilidad estimada: ${diag.probability}%
   🔍 Estado: Requiere evaluación adicional
   🏥 Especialidad: ${Array.isArray(diag.specialty) ? diag.specialty.join(', ') : diag.specialty || 'No especificada'}
`).join('')}` : ''}

──────────────────────────────────────────────────────────────
📊 CRITERIOS DIAGNÓSTICOS DEL DIAGNÓSTICO PRINCIPAL
──────────────────────────────────────────────────────────────
${datosMockSeleccionados.diagnosticCriteria ? `
📋 Descripción: ${datosMockSeleccionados.diagnosticCriteria.description}
🎯 Estado actual: ${datosMockSeleccionados.diagnosticCriteria.currentStatus}
✅ Criterios diagnósticos evaluados:
${datosMockSeleccionados.diagnosticCriteria.criteria ? 
  datosMockSeleccionados.diagnosticCriteria.criteria.map(criterio => `   • ${criterio}`).join('\n') : 
  '   • No se especificaron criterios detallados'}` : 
'📋 Criterios diagnósticos: No disponibles en el sistema'}

──────────────────────────────────────────────────────────────
🔍 DIAGNÓSTICO DIFERENCIAL
──────────────────────────────────────────────────────────────
${datosMockSeleccionados.differentialDiagnosis ? 
  datosMockSeleccionados.differentialDiagnosis.map((diag, index) => 
    `${index + 1}. ${diag.condition} (Probabilidad: ${diag.probability}%)
    📝 Características: ${diag.characteristics}
    ${diag.distinguishingFeatures ? `🔍 Características distintivas: ${diag.distinguishingFeatures}` : ''}`
  ).join('\n\n') : 
'🔍 Diagnóstico diferencial: No disponible en el sistema actual'}

──────────────────────────────────────────────────────────────
💡 ANÁLISIS DE SÍNTOMAS Y SIGNOS CLÍNICOS
──────────────────────────────────────────────────────────────
${datosMockSeleccionados.symptomAnalysis ? `
✅ SÍNTOMAS PRESENTES:
${datosMockSeleccionados.symptomAnalysis.present ? 
  datosMockSeleccionados.symptomAnalysis.present.map(sintoma => 
    `   • ${sintoma.symptom} (${sintoma.percentage}% de casos)
     📝 ${sintoma.description}`
  ).join('\n') : '   • No se registraron síntomas presentes'}

❌ SÍNTOMAS AUSENTES:
${datosMockSeleccionados.symptomAnalysis.absent ? 
  datosMockSeleccionados.symptomAnalysis.absent.map(sintoma => 
    `   • ${sintoma.symptom} (${sintoma.percentage}% de casos típicamente lo presentan)
     📝 ${sintoma.description}`
  ).join('\n') : '   • No se registraron síntomas ausentes'}

❓ SÍNTOMAS INDETERMINADOS:
${datosMockSeleccionados.symptomAnalysis.undetermined ? 
  datosMockSeleccionados.symptomAnalysis.undetermined.map(sintoma => 
    `   • ${sintoma.symptom}
     📝 ${sintoma.description || 'Requiere evaluación clínica adicional'}`
  ).join('\n') : '   • No hay síntomas en evaluación'}` : 
'💡 Análisis de síntomas: No disponible en el sistema actual'}

──────────────────────────────────────────────────────────────
🧪 PRUEBAS Y ESTUDIOS RECOMENDADOS
──────────────────────────────────────────────────────────────
${datosMockSeleccionados.recommendedTests ? 
  datosMockSeleccionados.recommendedTests.map(categoria => `
📂 ${categoria.category.toUpperCase()}:
${categoria.tests.map(prueba => 
  `   • ${prueba.name} (Urgencia: ${prueba.urgency})
     💡 Justificación: ${prueba.reason}
     ${prueba.expectedResults ? `📊 Resultados esperados: ${prueba.expectedResults}` : ''}`
).join('\n')}
`).join('') : 
'🧪 Pruebas recomendadas: No disponibles en el sistema actual'}

──────────────────────────────────────────────────────────────
📚 REFERENCIAS BIBLIOGRÁFICAS Y EVIDENCIA CIENTÍFICA
──────────────────────────────────────────────────────────────
${datosMockSeleccionados.references ? 
  datosMockSeleccionados.references.map((ref, index) => 
    `${index + 1}. ${ref.title}
    👥 Autores: ${ref.authors}
    📖 Revista: ${ref.journal} (${ref.year})
    ${ref.doi ? `🔗 DOI: ${ref.doi}` : ''}
    ${ref.relevance ? `📊 Relevancia: ${ref.relevance}` : ''}`
  ).join('\n\n') : 
'📚 Referencias bibliográficas: No disponibles en el sistema actual'}

──────────────────────────────────────────────────────────────
📈 DATOS EPIDEMIOLÓGICOS Y ESTADÍSTICOS
──────────────────────────────────────────────────────────────
${datosMockSeleccionados.visualization ? `
📊 PREVALENCIA POR GRUPOS DE EDAD:
${datosMockSeleccionados.visualization.prevalenceByAge ? 
  datosMockSeleccionados.visualization.prevalenceByAge.map(prev => 
    `   • ${prev.ageRange}: ${prev.prevalence}% de prevalencia`
  ).join('\n') : '   • Datos de prevalencia por edad no disponibles'}

⚠️ FACTORES DE RIESGO IDENTIFICADOS:
${datosMockSeleccionados.visualization.riskFactors ? 
  datosMockSeleccionados.visualization.riskFactors.map(factor => 
    `   • ${factor.factor}: ${factor.percentage}% de asociación`
  ).join('\n') : '   • Datos de factores de riesgo no disponibles'}

💀 DATOS DE MORTALIDAD:
${datosMockSeleccionados.visualization.mortality ? `
   • Mortalidad general: ${datosMockSeleccionados.visualization.mortality.overall}%
   • Con tratamiento adecuado: ${datosMockSeleccionados.visualization.mortality.withTreatment || datosMockSeleccionados.visualization.mortality.treated}%
   • Sin tratamiento: ${datosMockSeleccionados.visualization.mortality.withoutTreatment || datosMockSeleccionados.visualization.mortality.untreated}%` : 
'   • Datos de mortalidad no disponibles'}` : 
'📈 Datos epidemiológicos: No disponibles en el sistema actual'}

──────────────────────────────────────────────────────────────
📋 RESUMEN EJECUTIVO DEL PROCESO DIAGNÓSTICO
──────────────────────────────────────────────────────────────
• Total de diagnósticos evaluados: ${diagnosticosState.length}
• Diagnósticos confirmados: ${diagnosticosConfirmados.length}
• Diagnósticos descartados: ${diagnosticosDescartados.length}
• Diagnósticos pendientes: ${diagnosticosPendientes.length}
• Diagnóstico principal: ${diagnosticosConfirmados.length > 0 ? diagnosticosConfirmados[0].diagnosisName : 'No determinado'}
• Grado de certeza diagnóstica: ${diagnosticosConfirmados.length > 0 ? `${diagnosticosConfirmados[0].probability}%` : 'No determinado'}

──────────────────────────────────────────────────────────────
🏥 RECOMENDACIONES CLÍNICAS
──────────────────────────────────────────────────────────────
${diagnosticosConfirmados.length > 0 ? `
✅ DIAGNÓSTICO CONFIRMADO:
• Proceder con tratamiento específico para ${diagnosticosConfirmados[0].diagnosisName}
• Seguimiento clínico según protocolos establecidos
• Monitoreo de evolución y respuesta al tratamiento
${diagnosticosConfirmados.length > 1 ? 
`• Considerar manejo integral de diagnósticos secundarios` : ''}

📝 SEGUIMIENTO RECOMENDADO:
• Evaluación clínica periódica
• Monitoreo de signos y síntomas
• Ajuste terapéutico según evolución` : 
`⚠️ EVALUACIÓN DIAGNÓSTICA INCOMPLETA:
• Continuar con estudios complementarios
• Reevaluación clínica en 24-48 horas
• Considerar interconsulta especializada`}

──────────────────────────────────────────────────────────────
⚕️ INFORMACIÓN TÉCNICA DEL SISTEMA
──────────────────────────────────────────────────────────────
• Sistema: SaludTI - Asistente de Diagnóstico SNOMED CT
• Versión: 2.0 Professional
• Fecha de generación: ${fechaGeneracion}
• Médico responsable: ${paciente.medicoTratante || 'No especificado'}
• Validez del documento: Este es un documento de apoyo diagnóstico
• Disclaimer: La decisión diagnóstica final corresponde al criterio médico

══════════════════════════════════════════════════════════════
🔒 CONFIDENCIALIDAD MÉDICA
Este documento contiene información médica confidencial protegida por 
el secreto profesional. Su uso está restringido al personal sanitario 
autorizado y al paciente titular de la información.
══════════════════════════════════════════════════════════════

                            FIN DEL DOCUMENTO
══════════════════════════════════════════════════════════════`;
};


  // Función para cerrar documento clínico
  const handleCloseDocumentoClinico = () => {
    setDocumentoClinico(prev => ({ ...prev, open: false }));
  };

  // Manejador de cambio de pestaña
  const handleChangePestana = (event, newValue) => {
    setPestanaActiva(newValue);
  };

  // Componente para mostrar criterios diagnósticos
  const renderCriteriosDiagnosticos = () => {
    if (!datosMockSeleccionados?.diagnosticCriteria) return null;

    return (
      <div className="card mb-4">
        <div className="card-header">
          <h6 className="mb-0">Criterios Diagnósticos</h6>
        </div>
        <div className="card-body">
          <p className="mb-3">{datosMockSeleccionados.diagnosticCriteria.description}</p>
          <ul className="list-group list-group-flush">
            {datosMockSeleccionados.diagnosticCriteria.criteria.map((criterio, index) => (
              <li key={index} className="list-group-item px-0">
                <i className="bi bi-check-circle-fill text-success me-2"></i>
                {criterio}
              </li>
            ))}
          </ul>
          <div className="alert alert-info mt-3 mb-0">
            <strong>Estado actual:</strong> {datosMockSeleccionados.diagnosticCriteria.currentStatus}
          </div>
        </div>
      </div>
    );
  };

  // Componente para mostrar diagnóstico diferencial
  const renderDiagnosticoDiferencial = () => {
    if (!datosMockSeleccionados?.differentialDiagnosis) return null;

    return (
      <div className="card mb-4">
        <div className="card-header">
          <h6 className="mb-0">Diagnóstico Diferencial</h6>
        </div>
        <div className="card-body">
          {datosMockSeleccionados.differentialDiagnosis.map((diagnosis, index) => (
            <div key={index} className="row align-items-center mb-3">
              <div className="col-md-4">
                <strong>{diagnosis.condition}</strong>
              </div>
              <div className="col-md-5">
                <small className="text-muted">{diagnosis.characteristics}</small>
              </div>
              <div className="col-md-3">
                <div className="progress" style={{ height: '20px' }}>
                  <div 
                    className={`progress-bar ${diagnosis.probability >= 70 ? 'bg-danger' : diagnosis.probability >= 50 ? 'bg-warning' : 'bg-info'}`}
                    style={{ width: `${diagnosis.probability}%` }}
                  >
                    {diagnosis.probability}%
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    );
  };

  // Componente para mostrar análisis de síntomas
  const renderAnalisisSintomas = () => {
    if (!datosMockSeleccionados?.symptomAnalysis) return null;

    const { present, absent, undetermined } = datosMockSeleccionados.symptomAnalysis;

    return (
      <div className="card mb-4">
        <div className="card-header">
          <h6 className="mb-0">Análisis de Síntomas</h6>
        </div>
        <div className="card-body">
          <div className="row">
            <div className="col-md-4">
              <h6 className="text-success">Síntomas Presentes</h6>
              {present.map((symptom, index) => (
                <div key={index} className="mb-2">
                  <div className="d-flex justify-content-between">
                    <small>{symptom.symptom}</small>
                    <small className="text-success">{symptom.percentage}%</small>
                  </div>
                  <div className="progress" style={{ height: '4px' }}>
                    <div className="progress-bar bg-success" style={{ width: `${symptom.percentage}%` }}></div>
                  </div>
                  <small className="text-muted">{symptom.description}</small>
                </div>
              ))}
            </div>
            <div className="col-md-4">
              <h6 className="text-danger">Síntomas Ausentes</h6>
              {absent.map((symptom, index) => (
                <div key={index} className="mb-2">
                  <div className="d-flex justify-content-between">
                    <small>{symptom.symptom}</small>
                    <small className="text-danger">{symptom.percentage}%</small>
                  </div>
                  <div className="progress" style={{ height: '4px' }}>
                    <div className="progress-bar bg-danger" style={{ width: `${symptom.percentage}%` }}></div>
                  </div>
                  <small className="text-muted">{symptom.description}</small>
                </div>
              ))}
            </div>
            <div className="col-md-4">
              <h6 className="text-warning">Síntomas Indeterminados</h6>
              {undetermined.map((symptom, index) => (
                <div key={index} className="mb-2">
                  <div className="d-flex justify-content-between">
                    <small>{symptom.symptom}</small>
                    <small className="text-warning">{symptom.percentage ? `${symptom.percentage}%` : 'N/A'}</small>
                  </div>
                  {symptom.percentage && (
                    <div className="progress" style={{ height: '4px' }}>
                      <div className="progress-bar bg-warning" style={{ width: `${symptom.percentage}%` }}></div>
                    </div>
                  )}
                  <small className="text-muted">{symptom.description || 'Requiere evaluación'}</small>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    );
  };

  // Componente para mostrar pruebas recomendadas
  const renderPruebasRecomendadas = () => {
    if (!datosMockSeleccionados?.recommendedTests) return null;

    return (
      <div className="card mb-4">
        <div className="card-header">
          <h6 className="mb-0">Pruebas Recomendadas</h6>
        </div>
        <div className="card-body">
          {datosMockSeleccionados.recommendedTests.map((category, categoryIndex) => (
            <div key={categoryIndex} className="mb-4">
              <h6 className="text-primary mb-3">{category.category}</h6>
              <div className="table-responsive">
                <table className="table table-sm">
                  <thead>
                    <tr>
                      <th>Prueba</th>
                      <th>Urgencia</th>
                      <th>Justificación</th>
                    </tr>
                  </thead>
                  <tbody>
                    {category.tests.map((test, testIndex) => (
                      <tr key={testIndex}>
                        <td><strong>{test.name}</strong></td>
                        <td>
                          <span className={`badge ${
                            test.urgency === 'STAT' ? 'bg-danger' :
                            test.urgency === 'Urgente' ? 'bg-warning' :
                            'bg-info'
                          }`}>
                            {test.urgency}
                          </span>
                        </td>
                        <td><small>{test.reason}</small></td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          ))}
        </div>
      </div>
    );
  };

  // Componente para mostrar referencias
  const renderReferencias = () => {
    if (!datosMockSeleccionados?.references) return null;

    return (
      <div className="card mb-4">
        <div className="card-header">
          <h6 className="mb-0">Referencias Bibliográficas</h6>
        </div>
        <div className="card-body">
          {datosMockSeleccionados.references.map((reference, index) => (
            <div key={index} className="mb-3 p-3 border-start border-primary border-3 bg-light">
              <h6 className="mb-1">{reference.title}</h6>
              <p className="mb-1"><strong>Autores:</strong> {reference.authors}</p>
              <p className="mb-1"><strong>Revista:</strong> {reference.journal} ({reference.year})</p>
              {reference.doi && (
                <p className="mb-0"><strong>DOI:</strong> <code>{reference.doi}</code></p>
              )}
            </div>
          ))}
        </div>
      </div>
    );
  };
  
  // Componente SnomedVisualization actualizado (agregar al archivo)
function SnomedVisualization({ diagnosticId }) {
  // Validar que diagnosticId existe
  if (!diagnosticId) {
    return (
      <div className="col-md-12 mb-4">
        <div className="alert alert-warning">
          No se ha seleccionado un diagnóstico para mostrar la jerarquía SNOMED.
        </div>
      </div>
    );
  }

  const snomedData = formatHierarchyForDisplay(diagnosticId);
  
  return (
    <div className="col-md-12 mb-4">
      <div className="card">
        <div className="card-header">
          <h6 className="mb-0">Jerarquía SNOMED CT</h6>
        </div>
        <div className="card-body">
          {/* Diagnóstico Principal */}
          <div className="mb-4 p-3 bg-primary bg-opacity-10 rounded">
            <h5 className="text-primary mb-2">{snomedData.main.name}</h5>
            <p className="mb-0 text-muted">Código SNOMED: {snomedData.main.code}</p>
          </div>

          <div className="row">
            {/* Jerarquía (Árbol) */}
            <div className="col-md-6">
              <h6 className="mb-3">Jerarquía Taxonómica</h6>
              <div className="hierarchy-tree">
                {snomedData.path.length > 0 ? (
                  snomedData.path.map((level, index) => (
                    <div key={index} className="mb-3 p-2 border-start border-primary border-3" style={{ marginLeft: `${index * 10}px` }}>
                      <div className="d-flex align-items-start">
                        <span className="badge bg-primary me-2">{level.level}</span>
                        <div>
                          <div className="fw-medium">{level.name}</div>
                          <small className="text-muted">Código: {level.code}</small>
                          {level.description && (
                            <div className="text-muted small mt-1">{level.description}</div>
                          )}
                        </div>
                      </div>
                    </div>
                  ))
                ) : (
                  <p className="text-muted">No hay datos de jerarquía disponibles</p>
                )}
              </div>
            </div>

            {/* Subtipos */}
            <div className="col-md-6">
              <h6 className="mb-3">Subtipos</h6>
              <div className="subtypes-list">
                {snomedData.children.length > 0 ? (
                  snomedData.children.map((child, index) => (
                    <div key={index} className="mb-3 p-3 bg-light rounded">
                      <div className="d-flex align-items-start">
                        <i className="fas fa-angle-right text-info me-2 mt-1"></i>
                        <div className="flex-grow-1">
                          <div className="fw-medium">{child.name}</div>
                          <small className="text-muted">Código: {child.code}</small>
                          {child.description && (
                            <div className="text-muted small mt-1">{child.description}</div>
                          )}
                        </div>
                      </div>
                    </div>
                  ))
                ) : (
                  <p className="text-muted">No hay subtipos disponibles</p>
                )}
              </div>
            </div>
          </div>

          <div className="row mt-4">
            {/* Conceptos Relacionados */}
            <div className="col-md-6">
              <h6 className="mb-3">Conceptos Relacionados</h6>
              <div className="related-concepts">
                {snomedData.related.length > 0 ? (
                  snomedData.related.map((concept, index) => (
                    <div key={index} className="mb-2 p-2 border rounded">
                      <div className="d-flex align-items-start">
                        <span className="badge bg-secondary me-2">{concept.relationship}</span>
                        <div>
                          <div className="fw-medium">{concept.name}</div>
                          <small className="text-muted">Código: {concept.code}</small>
                          {concept.description && (
                            <div className="text-muted small mt-1">{concept.description}</div>
                          )}
                        </div>
                      </div>
                    </div>
                  ))
                ) : (
                  <p className="text-muted">No hay conceptos relacionados disponibles</p>
                )}
              </div>
            </div>

            {/* Mapeos */}
            <div className="col-md-6">
              <h6 className="mb-3">Códigos Equivalentes</h6>
              <div className="mappings">
                <div className="mb-2 p-2 border rounded">
                  <strong className="text-primary">ICD-10:</strong> 
                  <span className="ms-2">
                    {snomedData.mappings.icd10.length > 0 ? 
                      snomedData.mappings.icd10.join(", ") : 
                      "No disponible"
                    }
                  </span>
                </div>
                <div className="mb-2 p-2 border rounded">
                  <strong className="text-secondary">ICD-9:</strong> 
                  <span className="ms-2">
                    {snomedData.mappings.icd9.length > 0 ? 
                      snomedData.mappings.icd9.join(", ") : 
                      "No disponible"
                    }
                  </span>
                </div>
                {snomedData.mappings.cui && (
                  <div className="p-2 border rounded">
                    <strong className="text-success">CUI:</strong> 
                    <span className="ms-2">{snomedData.mappings.cui}</span>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

// Función formatHierarchyForDisplay actualizada (agregar al archivo)
function formatHierarchyForDisplay(diagnosticId) {
  try {
    console.log('=== DEBUG SNOMED ===');
    console.log('diagnosticId:', diagnosticId);
    console.log('completeSnomedHierarchy:', completeSnomedHierarchy);
    
    if (!completeSnomedHierarchy) {
      console.error('completeSnomedHierarchy no está definido');
      return {
        main: { name: "Error: datos SNOMED no cargados", code: "ERROR" },
        path: [],
        children: [],
        related: [],
        mappings: { icd10: [], icd9: [] }
      };
    }

    const hierarchy = completeSnomedHierarchy[diagnosticId];
    console.log('Datos encontrados para', diagnosticId, ':', hierarchy);
    
    if (!hierarchy) {
      console.warn('No se encontraron datos para diagnosticId:', diagnosticId);
      return {
        main: { name: `Diagnóstico no encontrado (ID: ${diagnosticId})`, code: "N/A" },
        path: [],
        children: [],
        related: [],
        mappings: { icd10: [], icd9: [] }
      };
    }
    
    // Adaptar a la estructura real de los datos
    const result = {
      main: {
        name: hierarchy.displayName || "Sin nombre",
        code: hierarchy.snomedCode || "N/A"
      },
      path: Array.isArray(hierarchy.hierarchy) ? hierarchy.hierarchy.map(level => ({
        level: level.level || "",
        name: level.name || "Sin nombre",
        code: level.code || "N/A",
        description: level.description || ""
      })) : [],
      children: Array.isArray(hierarchy.children) ? hierarchy.children.map(child => ({
        name: child.name || "Sin nombre",
        code: child.code || "N/A",
        description: child.description || ""
      })) : [],
      related: Array.isArray(hierarchy.relatedConcepts) ? hierarchy.relatedConcepts.map(concept => ({
        name: concept.name || "Sin nombre",
        code: concept.code || "N/A",
        relationship: concept.relationship || "",
        description: concept.description || ""
      })) : [],
      mappings: {
        icd10: Array.isArray(hierarchy.mappings?.icd10) ? hierarchy.mappings.icd10 : [],
        icd9: Array.isArray(hierarchy.mappings?.icd9) ? hierarchy.mappings.icd9 : [],
        cui: hierarchy.mappings?.cui || ""
      }
    };
    
    console.log('Resultado procesado:', result);
    return result;
    
  } catch (error) {
    console.error('Error al formatear jerarquía SNOMED:', error);
    console.error('Stack trace:', error.stack);
    return {
      main: { name: "Error al cargar datos SNOMED", code: "ERROR" },
      path: [],
      children: [],
      related: [],
      mappings: { icd10: [], icd9: [] }
    };
  }
}

// Componente renderVisualizaciones actualizado
const renderVisualizaciones = () => {
  if (!datosMockSeleccionados?.visualization) return null;

  const { visualization } = datosMockSeleccionados;

  return (
    <div className="card mb-4">      
      <div className="card-body">
        <div className="row">
          {/* NUEVA: Visualización SNOMED */}
          <SnomedVisualization diagnosticId={datosMockSeleccionados.id} />

          {/* Prevalencia por edad */}
          {visualization.prevalenceByAge && (
            <div className="col-md-6 mb-4">
              <h6>Prevalencia por Edad</h6>
              {visualization.prevalenceByAge.map((item, index) => (
                <div key={index} className="mb-2">
                  <div className="d-flex justify-content-between">
                    <span>{item.ageRange}</span>
                    <span>{item.prevalence}%</span>
                  </div>
                  <div className="progress" style={{ height: '8px' }}>
                    <div 
                      className="progress-bar bg-primary" 
                      style={{ width: `${(item.prevalence / Math.max(...visualization.prevalenceByAge.map(p => p.prevalence))) * 100}%` }}
                    ></div>
                  </div>
                </div>
              ))}
            </div>
          )}

          {/* Factores de riesgo */}
          {visualization.riskFactors && (
            <div className="col-md-6 mb-4">
              <h6>Factores de Riesgo</h6>
              {visualization.riskFactors.map((factor, index) => (
                <div key={index} className="mb-2">
                  <div className="d-flex justify-content-between">
                    <span>{factor.factor}</span>
                    <span>{factor.percentage}%</span>
                  </div>
                  <div className="progress" style={{ height: '8px' }}>
                    <div 
                      className="progress-bar bg-warning" 
                      style={{ width: `${factor.percentage}%` }}
                    ></div>
                  </div>
                </div>
              ))}
            </div>
          )}

          {/* Mortalidad */}
          {visualization.mortality && (
            <div className="col-md-12">
              <h6>Datos de Mortalidad</h6>
              <div className="row">
                <div className="col-md-4">
                  <div className="text-center p-3 bg-light rounded">
                    <h5 className="text-info">{visualization.mortality.overall}%</h5>
                    <small>Mortalidad General</small>
                  </div>
                </div>
                <div className="col-md-4">
                  <div className="text-center p-3 bg-light rounded">
                    <h5 className="text-success">{visualization.mortality.withTreatment || visualization.mortality.treated}%</h5>
                    <small>Con Tratamiento</small>
                  </div>
                </div>
                <div className="col-md-4">
                  <div className="text-center p-3 bg-light rounded">
                    <h5 className="text-danger">{visualization.mortality.withoutTreatment || visualization.mortality.untreated}%</h5>
                    <small>Sin Tratamiento</small>
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

  // Renderizado condicional del contenido de la pestaña
  const renderContenidoPestana = () => {
    if (!mostrarAnalisisDetallado || !diagnosticoSeleccionado) {
      return (
        <Box sx={{ 
          padding: '2rem', 
          textAlign: 'center', 
          backgroundColor: '#f8f9fa', 
          borderRadius: '8px',
          border: '2px dashed #dee2e6'
        }}>
          <Typography variant="body1" color="text.secondary">
            Seleccione un diagnóstico desde el panel de síntomas y haga clic en "Ver Detalle" para mostrar el análisis completo.
          </Typography>
        </Box>
      );
    }

    switch (pestanaActiva) {
      case 0: // Análisis General
        return (
          <div className="w-100">
            <div className="d-flex justify-content-between align-items-center mb-3">
              <h5>Análisis Detallado: {datosMockSeleccionados?.name || diagnosticoSeleccionado.nombre}</h5>
              <button 
                className="btn btn-sm btn-outline-secondary"
                onClick={handleCloseAnalysis}
              >
                <i className="bi bi-x-lg"></i> Cerrar
              </button>
            </div>
            
            {datosMockSeleccionados && (
              <div className="mb-3 p-3 bg-info bg-opacity-10 rounded">
                <h6>Descripción</h6>
                <p className="mb-2">{datosMockSeleccionados.description}</p>
                <small><strong>Código SNOMED:</strong> {datosMockSeleccionados.snomedCode}</small>
              </div>
            )}
            
            {renderCriteriosDiagnosticos()}
            {renderDiagnosticoDiferencial()}
            {renderAnalisisSintomas()}
          </div>
        );
        
      case 1: // Pruebas Recomendadas
        return (
          <div className="w-100">
            <div className="d-flex justify-content-between align-items-center mb-3">
              <h5>Pruebas Recomendadas: {datosMockSeleccionados?.name || diagnosticoSeleccionado.nombre}</h5>
              <button 
                className="btn btn-sm btn-outline-secondary"
                onClick={handleCloseAnalysis}
              >
                <i className="bi bi-x-lg"></i> Cerrar
              </button>
            </div>
            {renderPruebasRecomendadas()}
          </div>
        );
        
      case 2: // Referencias
        return (
          <div className="w-100">
            <div className="d-flex justify-content-between align-items-center mb-3">
              <h5>Referencias: {datosMockSeleccionados?.name || diagnosticoSeleccionado.nombre}</h5>
              <button 
                className="btn btn-sm btn-outline-secondary"
                onClick={handleCloseAnalysis}
              >
                <i className="bi bi-x-lg"></i> Cerrar
              </button>
            </div>
            {renderReferencias()}
          </div>
        );
        
      case 3: // Visualización
        return (
          <div className="w-100">
            <div className="d-flex justify-content-between align-items-center mb-3">
              <h5>Visualización: {datosMockSeleccionados?.name || diagnosticoSeleccionado.nombre}</h5>
              <button 
                className="btn btn-sm btn-outline-secondary"
                onClick={handleCloseAnalysis}
              >
                <i className="bi bi-x-lg"></i> Cerrar
              </button>
            </div>
            {renderVisualizaciones()}
          </div>
        );
        
      default:
        return (
          <Box sx={{ padding: '2rem', textAlign: 'center' }}>
            <Typography variant="body1" color="text.secondary">
              Seleccione una pestaña para comenzar
            </Typography>
          </Box>
        );
    }
  };

  return (
    <main id="app">
            <TopHeader />
    <Box sx={{ backgroundColor: '#f5f7fa', display: 'flex', flexDirection: 'column', height: '100vh', overflow: 'hidden' }}>
      {/* Fixed Header */}
      {/* <Box sx={{ 
        position: 'sticky', 
        top: 0, 
        zIndex: 1100,
        width: '100%',
      }}>
        <Header />
      </Box> */}
      
      {/* Main Content Area - Scrollable */}
      <Box sx={{ 
        display: 'flex', 
        flexGrow: 1,
        overflow: 'hidden',
      }}>
        {/* Left Column - Fixed Sidebar */}
        <Box sx={{ 
          width: '20%', 
          position: 'sticky',
          height: '100%',
          overflowY: 'auto',
          padding: '1rem',
          borderRight: '1px solid rgba(0, 0, 0, 0.1)',
        }}>
          {/* Patient Card */}
          <PatientCard paciente={paciente} />
          
          {/* Navigation Menu */}
          <div className="card mb-4">
            <div className="card-body">
              <div className="nav flex-column gap-2">
                <div className="nav-item">
                  <button className="nav-link bg-light deactive text-black rounded w-100 text-start">Resumen</button>
                </div>
                <div className="nav-item">
                  <button className="nav-link bg-info active text-white rounded w-100 text-start">
                    <strong>Asistente Diagnóstico</strong>
                  </button>
                </div>
                <div className="nav-item">
                  <button className="nav-link bg-light deactive text-black rounded w-100 text-start">Historia Clínica</button>
                </div>
                <div className="nav-item">
                  <button className="nav-link bg-light deactive text-black rounded w-100 text-start">Medicamentos</button>
                </div>
                <div className="nav-item">
                  <button className="nav-link bg-light deactive text-black rounded w-100 text-start">Laboratorio</button>
                </div>
                <div className="nav-item">
                  <button className="nav-link bg-light deactive text-black rounded w-100 text-start">Notas Clínicas</button>
                </div>
              </div>
            </div>
          </div>
        </Box>
        
       { /* Right Column - Scrollable Content */}
          <Box sx={{ 
            width: '80%', 
            flexGrow: 1, display: 'flex',
            flexDirection: 'column',
            height: '100%',
            overflow: 'hidden',
          }}>
            <Typography variant="h5" component="h1" gutterBottom sx={{
                            padding: '1rem',
                            backgroundColor: '#e3f2fd',
                            borderBottom: '1px solid rgba(0, 0, 0, 0.1)',
                            textAlign: 'center',
                            fontWeight: 'bold',
                            color: '#1976d2',
                            }}>
                            <AssessmentOutlined sx={{ verticalAlign: 'middle', marginRight: '0.5rem' }} />
                              Asistente de Diagnóstico Basado en Patrones SNOMED
                            </Typography>
          {/* Content Area */}
          <Box sx={{ 
            flexGrow: 1,
            overflow: 'hidden',
            display: 'flex',
            flexDirection: 'column',
          }}>
            {/* Two Column Layout */}
            <Box sx={{ 
              display: 'flex', 
              height: '100%',
              overflow: 'hidden',
            }}>
              {/* Left Panel - Symptoms */}
              <Box sx={{ 
                width: '40%', 
                padding: '1rem',
                borderRight: '1px solid rgba(0, 0, 0, 0.1)',
                overflowY: 'auto',
              }}>
                
                <SymptomsAndFindings 
  onDiagnosisSelect={handleDiagnosisSelection}
  onDiagnosisStatusChange={handleDiagnosisStatusChange}
  onSintomasChange={handleSintomasChange} // <- Agregar esta línea
/>
              </Box>
              
              {/* Right Panel - Analysis */}
              <Box sx={{ 
                width: '60%', 
                overflowY: 'auto',
              }}>
                {/* Tab Navigation - Fixed */}
                <Box sx={{ 
                  position: 'sticky',
                  top: 0,
                  backgroundColor: 'white',
                  zIndex: 100,
                  borderBottom: '1px solid rgba(0, 0, 0, 0.1)',
                }}>
                  <Tabs
                    value={pestanaActiva}
                    onChange={handleChangePestana}
                    variant="scrollable"
                    scrollButtons="auto"
                    aria-label="pestañas diagnóstico"
                    sx={{
                      minHeight: '48px',
                      '& .MuiTab-root': {
                        minHeight: '48px',
                        textTransform: 'none',
                        fontSize: '0.875rem',
                      }
                    }}
                  >
                    <Tab 
                      icon={<AssessmentOutlined />} 
                      label="Análisis" 
                      iconPosition="start"
                      sx={{ minWidth: '120px' }}
                    />
                    <Tab 
                      icon={<MedicalServices />} 
                      label="Pruebas" 
                      iconPosition="start"
                      sx={{ minWidth: '120px' }}
                    />
                    <Tab 
                      icon={<LibraryBooksOutlined />} 
                      label="Referencias" 
                      iconPosition="start"
                      sx={{ minWidth: '120px' }}
                    />
                    <Tab 
                      icon={<VisibilityOutlined />} 
                      label="Visualización" 
                      iconPosition="start"
                      sx={{ minWidth: '120px' }}
                    />
                  </Tabs>
                </Box>
                
                {/* Tab Content - Scrollable */}
                <Box sx={{ 
                  padding: '1rem',
                  height: 'calc(100% - 48px)',
                  overflowY: 'auto',
                }}>
                  {renderContenidoPestana()}
                </Box>
              </Box>
            </Box>
          </Box>
          
          {/* Floating Action Button for Clinical Document */}
          {mostrarAnalisisDetallado && datosMockSeleccionados && (
            <Box sx={{
              position: 'fixed',
              bottom: '2rem',
              right: '2rem',
              zIndex: 1000,
            }}>
              <Button
                variant="contained"
                color="primary"
                size="large"
                startIcon={<ArticleOutlined />}
                onClick={handleGenerarDocumentoClinico}
                sx={{
                  borderRadius: '50px',
                  padding: '12px 24px',
                  boxShadow: '0 4px 12px rgba(0,0,0,0.3)',
                  '&:hover': {
                    boxShadow: '0 6px 16px rgba(0,0,0,0.4)',
                  }
                }}
              >
                Generar Documento Clínico
              </Button>
            </Box>
          )}
        </Box>
      </Box>
      
      {/* Modal for Clinical Document */}
      {/* Eliminar todo el Modal y dejar solo: */}
{documentoClinico.open && datosMockSeleccionados && (
  <DocumentoClinico
    open={documentoClinico.open}
    onClose={() => setDocumentoClinico(prev => ({ ...prev, open: false }))}
    paciente={documentoClinico.paciente}
    diagnosticoSeleccionado={documentoClinico.diagnosticoSeleccionado}
    datosMockSeleccionados={documentoClinico.datosMockSeleccionados}
    diagnosticosConfirmados={documentoClinico.diagnosticosConfirmados}
    diagnosticosDescartados={documentoClinico.diagnosticosDescartados}
    sintomasSeleccionados={documentoClinico.sintomasSeleccionados}
  />
)}
    </Box>
    </main>
  );
};

export default DiagnosticAssistantList;